import React, { ChangeEvent } from 'react';

type JSFile = File;

type FileInputProps = {
  files: JSFile[];
  onChange: (files: JSFile[]) => unknown;
  maxFileSize: number;
  maxCount: number;
  allowedFileTypes: string[];
};

export const FileInput = React.forwardRef<HTMLInputElement, FileInputProps>(
  ({ files, onChange, maxFileSize, maxCount, allowedFileTypes }, ref) => {
    const getErorMessage = (newFiles: JSFile[]): string => {
      if (newFiles.length + files.length >= maxCount) {
        return `You may only upload ${maxCount} files at once`;
      }
      for (let i = 0; i < newFiles.length; i++) {
        const file = newFiles[i];
        if (file.size > maxFileSize) {
          return `File must not be larger than ${maxFileSize}`;
        }
        if (allowedFileTypes.length && !allowedFileTypes.includes(file.type)) {
          return `File of type ${file.type} not supported`;
        }
      }

      return null;
    };

    const onFileChange = (e: ChangeEvent<HTMLInputElement>) => {
      const newFiles = Array.from(e.target.files);
      const errorMessage = getErorMessage(newFiles);
      if (errorMessage) {
        alert(errorMessage);
        return;
      }

      onChange([...files, ...newFiles]);
    };

    return (
      <input
        ref={ref}
        type="file"
        hidden
        onChange={onFileChange}
        multiple={maxCount !== 1}
      />
    );
  }
);
